<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kategori</label>
            <input class="form-control" v-model="value.Name" placeholder="Kategori"/>
        </div>
        <div class="col-12">
            <label class="form-label">Öncelik</label>
            <input class="form-control" type="number" v-model="value.Priority" placeholder="Kategori"/>
        </div>
    </div>
</template>

<script>
export default{
    props:{
        value:Object
    }
}
</script>